export * from './product-detail-layout';
